<template>
    <li>
    <h3>{{ fullName }}</h3>
    <h4>{{ rate }}$/hour</h4>
    <div>
        <base-badge v-for="area in areas" :key="area" :type="area" :title="area"></base-badge>
    </div>
    <div>
        <base-button link :to="contactLink">  Contact Coach</base-button>
        <base-button link :to="detailsLink">View Details</base-button>
    </div>
</li>
</template>

<script>
import BaseButton from './UI/BaseButton.vue'
export default {
  components: { BaseButton },
    props:['id','firstName','rate','areas','lastName'],
    mounted(){

    },
    computed:{
        contactLink(){
            return `${this.$route.path}/${this.id}/contact`
        },
        detailsLink(){
            return `${this.$route.path}/${this.id}`
        },
        fullName(){
            return `${this.firstName} ${this.lastName}`
        }
    }
}
</script>

<style scoped>
li {
  margin: 1rem 0;
  border: 1px solid #424242;
  border-radius: 12px;
  padding: 1rem;
}

h3 {
  font-size: 1.5rem;
}

h3,
h4 {
  margin: 0.5rem 0;
}

div {
  margin: 0.5rem 0;
}

.actions {
  display: flex;
  justify-content: flex-end;
}
</style>